import React from 'react';
import { useTranslation } from 'react-i18next';

export default () => {

    const { t } = useTranslation();
    return (
        <>
            <p>Hi this is CollectionFee.Home</p>
            <p>{t('US.COLLECTION.ADMIN:COLLECTIONFEE.TEST')}</p>
        </>
    )
}